import React from 'react'
import "./Build.scss"
function Build() {
  return (
    <div className='build-container'>
        <div className="build-wrap">
        <span>Customer Relationship Management (CRM)</span>
        <header>Build Stronger Customer Relationships</header>
        <p>A powerful CRM system to streamline onboarding and manage customer interactions effectively</p>
        </div>
    </div>
  )
}

export default Build